import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// Add routes dynamically in views
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior () {
    document.getElementById('app').scrollTop = 0;
  }
})

router.beforeResolve(function (to, from, next) {
  if (to.fullPath === '/') {
    next({ name: 'dashboard' })
    return
  }
  // if matched routes doesn't exist - go to root or 404
  return to.matched.length ? next() : next({ name: 'dashboard' })
})

export default router
